import * as THREE from 'three';
import { useEffect, useRef } from 'react';
import { viewerState } from './viewerState.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { TransformControls } from 'three/addons/controls/TransformControls.js';

export function Viewer({sx={}}){
	const ref = useRef(null);
	useEffect(() => {
    let canvas = ref.current;
    const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
		console.log("Starting viewer");
    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    }
		let width = ref.current.offsetWidth;
		let height = ref.current.offsetHeight;
		//const camera = new THREE.PerspectiveCamera(
			//75, aspectRatio, 0.1, 10000
		//);
		const camera = new THREE.OrthographicCamera(
			width / -2, width / 2, height / 2, height / -2, 1, 10000
		);
		viewerState.setCamera(camera);
		//renderer.setSize(width, height);
		const controls = new OrbitControls(camera, renderer.domElement);
		controls.update();
		const partControl = new TransformControls(camera, renderer.domElement);
		partControl.setSpace("global");
		partControl.addEventListener( 'dragging-changed', function ( event ) {
			controls.enabled = ! event.value;
		} );
		viewerState.setPartControl(partControl);
		//renderer.render( scene, camera );
		function render(){
      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        const _width = canvas.clientWidth;
        const _height = canvas.clientHeight;
        camera.left = - _width / 2; 
        camera.right = _width / 2;
        camera.top = _height / 2;
        camera.bottom = - _height / 2;
        camera.updateProjectionMatrix();
      }
			renderer.render( viewerState.getScene(), camera );
		}
    window.addEventListener("resize", render);
		partControl.addEventListener("change", render);
		partControl.addEventListener("objectChange", viewerState.transformCallback);
		controls.addEventListener("change", render);
    const raycaster = new THREE.Raycaster()
    function selectBottomFace (e){
      const canvas = renderer.domElement;
      const offset = canvas.offsetTop;
      const _width = canvas.clientWidth;
      const _height = (canvas.clientHeight);
      const mouse = new THREE.Vector2()
      mouse.set((e.clientX / _width) * 2 - 1, -((e.clientY - offset)/ _height) * 2 + 1)
      raycaster.setFromCamera(mouse, camera)
      function isPartOfTransformControls(object){
        let current = object;
        while(current){
          if(current.isTransformControlsPlane || current.isTransformControlsRoot){
            return true;
          }
          current = current.parent;
        }
        return false;
      }
      const intersects = raycaster.intersectObjects(viewerState.getScene().children, true)
        .filter(hit => !isPartOfTransformControls(hit.object))
      if(intersects.length > 0 && intersects[0].normal){
        const closest = intersects[0]
        const normal = closest.normal.clone();
        normal.applyQuaternion(closest.object.quaternion);
        const down = new THREE.Vector3(0, 0, -1);
        if(normal.dot(down) > -0.999){
          const qxyz = normal.clone().cross(down);
          console.log(normal, qxyz, normal.dot(down))
          const q = new THREE.Quaternion(
            qxyz.x, qxyz.y, qxyz.z, 1 + normal.dot(down)
          );
          console.log(q);
          q.normalize();
          viewerState.setQuaternionForCurrentMesh(q);
        }else{
          const q = new THREE.Quaternion(
            1, 0, 0, 0
          );
          console.log(q);
          viewerState.setQuaternionForCurrentMesh(q);
        }
      }
      console.log(intersects);
    }
    viewerState.setActivateBottomFace(()=>{
      renderer.domElement.addEventListener("click", selectBottomFace)
    })
    viewerState.setDeactivateBottomFace(()=>{
      renderer.domElement.removeEventListener("click", selectBottomFace)
    })
		viewerState.setRender(render);
		return () => {
			viewerState.setPartControl(null);
			partControl.dispose();
      renderer.dispose();
			console.log("Stopping viewer");
      window.removeEventListener("resize", render);
      renderer.domElement.removeEventListener("click", selectBottomFace);
      viewerState.setActivateBottomFace(()=>{});
      viewerState.setDeactivateBottomFace(()=>{});
      viewerState.setRender(()=>{});
		}
	});
	return (
    <canvas className="viewer" ref={ref}></canvas>
	)
}
